import _ from 'lodash';
import moment from 'moment';

// eslint-disable-next-line
export function date({ date, format }) {
    if (!date) {
        return '';
    }

    let momentDate;

    // If just a date (no time included), make sure the resulting moment
    // object is not shifted to another date due to timezone offsets
    if (_.isString(date) && !_.includes(date, ':')) {
        momentDate = moment(date).startOf('day');
    } else {
        // Parse as UTC, display in local time
        momentDate = moment.utc(date).local();
    }

    if (!momentDate.isValid() && date.date) {
        // Try treating it as a mysql utc date.
        momentDate = moment(`${date.date} +0000`, 'YYYY-MM-DD HH:mm:ss ZZ');
    }

    if (format === 'year') {
        return momentDate.format('ddd, MMM D, YYYY');
    }

    if (format === 'monthDateYear') {
        return momentDate.format('MMM D, YYYY');
    }

    if (format === 'compact') {
        return momentDate.format('M/D/YY');
    }

    if (format === 'time') {
        return momentDate.format('MMM D, YYYY, h:mma');
    }

    if (format === 'timeOnly') {
        if (momentDate.get('minutes')) {
            return momentDate.format('h:mma');
        }
        return momentDate.format('ha');
    }
    return momentDate.format('ddd, MMM D');
}
